(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.View_Audit_Breadcrumb = (function(superClass) {
    extend(View_Audit_Breadcrumb, superClass);

    function View_Audit_Breadcrumb() {
      return View_Audit_Breadcrumb.__super__.constructor.apply(this, arguments);
    }

    View_Audit_Breadcrumb.prototype.init = function(id) {
      var opt;
      this.layoutUrl = 'backend/portal/audit/view-breadcrumb';
      this.refreshNavHandler = false;
      opt = {
        'postOptions': {
          'at_id': id
        }
      };
      this.createDialog(opt);
      this.openDialog();
      return this.displayLoadingMessage();
    };

    View_Audit_Breadcrumb.prototype.afterLoadLayout = function(selector) {
      var sizeY;
      this.setPosition();
      sizeY = $(this.parent.layoutSelector).find('.modal-body').height() - 60;
      if ($(selector).find('.table').height() < sizeY) {
        sizeY = $(selector).find('.table').height();
      }
      return this.table = $(selector).find(".table").dataTable({
        "sScrollY": sizeY + "px",
        "bPaginate": false,
        "bScrollCollapse": true,
        "bFilter": false,
        "bInfo": false,
        "bSort": false
      });
    };

    return View_Audit_Breadcrumb;

  })(DialogHandler);

}).call(this);
